export default __webpack_public_path__ + "static/media/P_wdt_c_cap_2.002a61ba.mp3";